<template>
  <section class="all-cases-view" v-loading="loading">
    <div class="primary-content-view-new">
      <div
        class="listings listings__table listings__all-cases"
        v-if="hospitalAccountManagers"
      >
        <el-table :data="hospitalAccountManagers.data">
          <el-table-column label="Username" max-width="300">
            <template v-slot="scope">
              <span class="text-center">{{ scope.row.username }}</span>
            </template>
          </el-table-column>

          <el-table-column label="Name" width="250">
            <template v-slot="scope"
              >{{ convertToUppercase(scope.row.first_name) }} {{ convertToUppercase(scope.row.last_name) }}</template
            >
          </el-table-column>

          <el-table-column label="Email" max-width="300">
            <template v-slot="scope">{{ scope.row.email }}</template>
          </el-table-column>

          <el-table-column label="Phone" width="250">
            <template v-slot="scope">{{ scope.row.phone }}</template>
          </el-table-column>
          <el-table-column label="Account Status" width="200">
            <template #default="scope">
              <div class="column-status">
                <el-dropdown
                  class="status-dropdown"
                  @command="
                    (command) =>
                      changeStatus(command, scope.row._id, scope.$index,scope.row.userName)
                  "
                  trigger="click"
                >
                  <span class="el-dropdown-link">
                    <el-tag :type="getStatusType(scope.row.status)">{{
                      scope.row.status
                    }}</el-tag>
                  </span>

                  <template #dropdown>
                    <el-dropdown-menu class="status-dropdown-menu">
                      <el-dropdown-item
                        v-if="scope.row.status !== 'INACTIVE'"
                        command="INACTIVE"
                        >INACTIVE</el-dropdown-item
                      >
                      <el-dropdown-item
                        v-if="scope.row.status !== 'ACTIVE'"
                        command="ACTIVE"
                        >ACTIVE</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </template>
                </el-dropdown>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            prop="action"
            label="Action"
            fixed="right"
            width="100"
          >
            <template v-slot="scope">
              <ul class="listings__action-buttons">
                <li>
                  <el-button
                    title="Reset password"
                    @click="onPasswordReset(scope.row)"
                    class="view-button"
                  >
                    <img
                      class="action-active"
                      src="@/assets/images/icons/actions/reset-active.svg"
                      alt="icon"
                    />
                    <img
                      class="action-inactive"
                      src="@/assets/images/icons/actions/reset-deactive.svg"
                      alt="icon"
                    />
                  </el-button>
                </li>
                <li v-if="hasPermission('hospital_manager', 'edit')">
                  <el-button
                    title="Edit"
                    @click="onEdit(scope.row)"
                    class="edit-button"
                    disabled
                  >
                    <img
                      class="action-active"
                      src="@/assets/images/icons/actions/edit-active.svg"
                      alt="icon"
                    />
                    <img
                      class="action-inactive"
                      src="@/assets/images/icons/actions/edit-deactive.svg"
                      alt="icon"
                    />
                  </el-button>
                </li>
              </ul>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="listings listings__pagination">
        <el-pagination
          v-model:currentPage="page"
          v-model:page-size="pageSize"
          :page-sizes="[20, 25, 50, 100]"
          layout=" prev, pager, next, jumper, sizes ,total"
          :total="hospitalAccountManagers.total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <el-dialog v-model="editAccountManagerDialog">
      <EditAccountManager></EditAccountManager>
    </el-dialog>
    <div class="default-modal">
      <div v-if="SuccessPopup">
        <el-dialog top="15%" width="30%" v-model="SuccessPopup">
          <div class="popup-date pb-0">
            <div class="text-center">
              <img
                src="@/assets/images/icons/cases/success-popup-icon.svg"
                alt="icon"
              />
            </div>
            <div class="text-center mt-25">
              User Password reset Successfully! <br />
              User will recieve Email with new password !
            </div>
            <div class="dialog-footer justify-center">
              <el-button class="blue-save-button" @click="SuccessPopup = false">
                OK
              </el-button>
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </section>
</template>

<script>
import { defineAsyncComponent } from "vue";
import { mapGetters } from "vuex";
const EditAccountManager = defineAsyncComponent(() =>
  import("@/components/hospitals/accountsManagers/EditAccountManager")
);
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
export default {
  mixins: [UserPermissionsHelper],
  data() {
    return {
      editAccountManagerDialog: false,
      page: 1,
      pageSize: 10,
      loading: false,
      hospitalAccountManagers: {},
      SuccessPopup: false,
    };
  },
  components: {
    EditAccountManager,
  },
  computed: {
    ...mapGetters("hospitals", [
      "getHospitalAccountManagers",
      "getHospitalAccountManagerDeleteStatus",
    ]),
    ...mapGetters("userAccounts", [
      "getUserAccountStatusUpdated",
      "getUserAccountErrors",
      "getUserPasswordResetStatus",
    ]),
    hospital_id() {
      if (this.$route.params.hospital_id) {
        return this.$route.params.hospital_id;
      }
      return null;
    },
    getStatusType() {
      return (statusVal) => {
        const status = statusVal.trim();
        if (status == "ACTIVE") {
          return "default";
        } else if (status == "INACTIVE") {
          return "danger";
        } else {
          return "";
        }
      };
    },
  },
  async mounted() {
    await this.fetchAccountManagersList(this.page);
  },
  methods: {
    async fetchAccountManagersList(page) {
      this.page = page;
      this.loading = true;
      let params = { hospital_id: this.hospital_id, page: this.page };
      await this.$store.dispatch(
        "hospitals/fetchHospitalAccountManagers",
        params
      );
      this.loading = false;
      this.hospitalAccountManagers = JSON.parse(
        JSON.stringify(this.getHospitalAccountManagers)
      );
    },

    async onEdit(id) {
      this.$router.push({
        name: "EditAccountManager",
        params: {
          user_id: id._id,
        },
        query: this.$route.query,
      });
    },
    async onDelete(id) {
      this.$confirm("Are you sure to delete Account Manager?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning",
      }).then(() => {
        this.deleteAccountManager(id);
      });
    },
    async deleteAccountManager(id) {
      let params = {
        hospital_id: this.hospital_id,
        account_manager_id: id,
      };
      await this.$store.dispatch(
        "hospitals/deleteHospitalAccountManager",
        params
      );
      if (this.getHospitalAccountManagerDeleteStatus) {
        successNotification("Account Manager deleted successfully");
        this.loading = true;
        await this.fetchAccountManagersList(1);
        this.loading = false;
      } else {
        errorNotification("Error while deleting Account Manager");
      }
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.page = 1;

      this.fetchAccountManagersList();
    },
    handleCurrentChange(page) {
      this.page = page;

      this.fetchAccountManagersList();
    },
    onPasswordReset(user) {
      let userId = user._id;
      let userName = user.first_name + " " + user.last_name;

      this.$confirm(
        `Are you sure want to  Reset <b>${
          userName || "User"
        }</b> 's Password. Continue ?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      ).then(async () => {
        await this.resetPassword(userId);
      });
    },
    async changeStatus(command, id, index, userName) {
      await this.$alert(
        `You are not allowed to edit the status of ${
          userName || "this User"
        }.`,
        "Warning",
        {
          confirmButtonText: "OK",
          type: "warning",
        }
      );
        },
    async resetPassword(id) {
      try {
        let params = {
          id,
        };
        await this.$store.dispatch(
          "userAccounts/resetUserAccountPassword",
          params
        );
        if (this.getUserPasswordResetStatus) {
          this.SuccessPopup = true;
        } else if (this.getUserAccountErrors) {
          this.$notify.error({
            title: "Error",
            message: this.getUserAccountErrors.critical_error,
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>
